<script>
    import { getContext } from "svelte";
    import { key } from "../context/cinemaTileDimension";
    import { key as add2BasketButtonCtxKey, supportedColors as add2BasketButtonColors, ButtonColor } from "../context/add2BasketButton.js";
    import Add2BasketButton from "./Add2BasketButton.svelte";
    import CleanTopInfo from "./CleanTopInfo.svelte";

    /**
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        brandName,
        variation,
        showTopInfo = false,
        widgetAdditionalClickTracking,
        additionalClickTracking,
        add2BasketVisibleTrack,
    } = $props();

    const add2BasketButton = getContext(add2BasketButtonCtxKey);
    const tileDimensions = getContext(key);
</script>

<div
    data-testid="clean-product-information-component"
    style:width={`${tileDimensions.width}px`}
    class="reco_cinema__information-container oc-mt-75"
>
    <div class="reco_cinema__brand oc-text-color-default oc-copy-75">
        {brandName}
    </div>
    <div class="reco_cinema__name otto_sans_ko_medium">
        {variation.name}
    </div>
    {#if add2BasketButtonColors.includes(add2BasketButton?.buttonColor)}
        <div class="oc-mt-50 oc-mb-50">
            <Add2BasketButton
                variationId={variation.id}
                {widgetAdditionalClickTracking}
                {additionalClickTracking}
                isRedVariant={add2BasketButton?.buttonColor === ButtonColor.RED}
                {add2BasketVisibleTrack}
            />
        </div>
    {/if}
    {#if showTopInfo}
        <div data-testid="product_top_info">
            <CleanTopInfo {variation} />
        </div>
    {/if}
</div>

<style lang="scss">
    :root {
        --padding_within_cell: 8px;
    }

    .reco_cinema__brand {
        text-transform: uppercase;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-bottom: var(--oc-semantic-spacing-12);
    }

    .reco_cinema__information-container {
        text-align: left;
        overflow: hidden;
        max-width: 100%;
    }

    .reco_cinema__name {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        line-height: 1.2;
        color: #212121;
        margin-bottom: 5px;
    }

    .otto_sans_ko_medium {
        font-family: "OTTO Sans KO", sans-serif;
        font-weight: 500;
        font-style: normal;
    }
</style>
